import React, { useEffect, useRef, useState } from "react";
import styles from "./FiltersDropdown.module.css";
import Checkbox from "@/shared/ui/Checkbox/index.js";

export default function FiltersDropdown({
                                            categories = [],
                                            selectedCategories = [],
                                            onChangeCategories = () => {},

                                            formats = [],
                                            selectedFormats = [],
                                            onChangeFormats = () => {},

                                            isLoading = false,
                                        }) {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        const onEsc = (e) => e.key === "Escape" && setIsOpen(false);

        document.addEventListener("mousedown", onDocClick);
        document.addEventListener("keydown", onEsc);
        return () => {
            document.removeEventListener("mousedown", onDocClick);
            document.removeEventListener("keydown", onEsc);
        };
    }, []);

    const toggleCategory = (id) => {
        if (selectedCategories.includes(id)) {
            onChangeCategories(selectedCategories.filter((c) => c !== id));
        } else {
            onChangeCategories([...selectedCategories, id]);
        }
    };

    const toggleFormat = (id) => {
        if (selectedFormats.includes(id)) {
            onChangeFormats(selectedFormats.filter((f) => f !== id));
        } else {
            onChangeFormats([...selectedFormats, id]);
        }
    };

    return (
        <div className={styles.wrapper} ref={wrapperRef}>
            <button
                type="button"
                className={`${styles.header} ${isOpen ? styles.headerOpen : ""}`}
                onClick={() => setIsOpen((v) => !v)}
                aria-expanded={isOpen}
            >
                <h3 className={styles.headerTitle}>ФИЛЬТРЫ</h3>
                <span className={`${styles.arrow} ${isOpen ? styles.arrowUp : ""}`} />
            </button>

            {isOpen && (
                <div className={styles.popup} role="dialog" aria-label="Фильтры">
                    <div className={styles.columns}>
                        <div className={styles.block}>
                            <p className={styles.title}>СИСТЕМА</p>

                            {isLoading ? (
                                <p className={styles.row}>Загрузка...</p>
                            ) : (
                                categories.map((cat) => (
                                    <Checkbox
                                        key={cat.id}
                                        checked={selectedCategories.includes(cat.id)}
                                        onChange={() => toggleCategory(cat.id)}
                                        label={cat.label ?? cat.name ?? String(cat.id)}
                                        className={styles.row}
                                    />
                                ))
                            )}
                        </div>

                        <div className={styles.block}>
                            <p className={styles.title}>ФОРМАТ</p>

                            {formats.map((fmt) => (
                                <Checkbox
                                    key={fmt.id}
                                    checked={selectedFormats.includes(fmt.id)}
                                    onChange={() => toggleFormat(fmt.id)}
                                    label={fmt.label}
                                    className={styles.row}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
